import LocaleService from '../services/locale.service';

export class CurrencyHelper {
  public static toLocaleStringWithZeroOrTwoDigits(value: number | undefined): string {
    if (!value) {
      return '';
    }
    if (+value % 1 !== 0) {
      // url: https://stackoverflow.com/a/39686116
      const locale = window.navigator.language || LocaleService.getLocale();
      return `${(+value).toLocaleString(locale, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} kr`;
    }
    return `${value} kr`;
  }
}
